import { useContext, useMemo } from 'react';

import { MeContext } from 'App';

type NotAllowed = {
  isAllowed: false;
};

type Allowed = {
  isAllowed: true;
  attributeName: string;
};

type AllowAttributeReplace = NotAllowed | Allowed;

export function useAllowAttributeReplace(): AllowAttributeReplace {
  const {
    metaData: { actions },
  } = useContext(MeContext);

  return useMemo<AllowAttributeReplace>(() => {
    if (
      'partialReplaceAttribute' in actions &&
      actions.partialReplaceAttribute
    ) {
      return {
        isAllowed: true,
        attributeName: actions.partialReplaceAttribute,
      };
    }

    return {
      isAllowed: false,
    };
  }, [actions]);
}
